import http from '~/http/services/pos';
import { ApiResponse } from '~/types/Api';
import { UserData } from '../../types/Users';

export type LoginResponse = ApiResponse<{
  token: string;
  user: UserData;
}>;

export const login = async (body: { username: string; pin: string }) => {
  return http.post<LoginResponse>('/api/v1/login', body);
};
